export default {
  user: {
    userType: "用户类型",
    userInfo: "Chi tiết người dùng",
    levelInfoCell: "Cấp độ và Người dùng trực tiếp",
    accountInfoCell: "thông tin tài khoản（90 ngày gần đây）",
    statusInfo: "trạng thái",
    dateInfo: "thông tin ngày tháng",
    remark: "ghi chú",
    option: "thao tác",
    id: "người dùng",
    account: "tài khoản",
    realName: "tên thật",
    nickName: "Tên hiển thị",
    email: "hộp thư",
    phone: "số điện thoại",
    inviteName: "Tài khoản mời",
    inviteCode: "Mã mời",
    proxyName: "Cấp trên mời",
    platformName: "Nền tảng",
    proxyId: "Cấp trên",
    userTierName: "Nhóm người dùng",
    userNum: "số cấp dưới trực tiếp",
    balance: "Số tiền khả dụng",
    onlineStatus: "trạng thái trực tuyến",
    onlineStatus0: "ngoại tuyến",
    onlineStatus1: "trực tuyến",
    createTime: "Thời gian đăng ký",
    loginTime: "lần đăng nhập cuối",
    loginIp: "IP đăng nhập",
    registerIp: "IP đăng ký",
    leaveDayNum: "Số ngày không đăng nhập",
    leaveDayNum3: "hơn 3 ngày",
    leaveDayNum7: "hơn 7 ngày",
    leaveDayNum15: "hơn 15 ngày",
    platformCode: "nền tảng bạn thuộc về",
    dayClosingOrderCount: "Số đơn thanh toán",
    earningsClosingAmount: "Số tiền đợi thanh toán",
    dayValidAmount: "Số tiền cược thực tế",
    dayResult: "tiền thắng thua",
    allBetAmount: "số tiền cược",
    allEarningsAmount: "tiền cược",
    directlyUnderEarningsAmount: "Tổng thắng thua của cấp dưới trực tiếp",
    today: "hôm nay",
    nearly90: "90 ngày gần đây",
    baseInfoTitle: "thông tin cơ bản",
    directUserTitle: "Người dùng trực tiếp",
    directlyUnderMemberCount: "Số lượng người dùng trực tiếp",
    underMemberCount: "số người dùng thành viên",
    walletAccountTitle: "ví tiền",
    thirdBalance: "số dư của bên thứ ba",
    rebateBackAmount: "Số tiền hoàn trả",
    bettingInfoTitle: "Thông tin đặt cược",
    bettingInfoSubtitle: "(Tin nhắn 90 ngày gần đây)",
    earningsClosingCount: "Số đơn cược đợi thanh toán",
    allBetCount: "Số lần đặt cược tích lũy",
    drawBackLog: "Lịch sử chiết khấu hoa hồng",
    amountLog: "Lịch sử thay đổi tài khoản",
    userOrder: "Lịch sử cược",
    lowerUserOrder: "Lịch sử đặt cược cấp dưới",
    lowerUser: "Người dùng cấp dưới",
    bonusSetting: "Hoàn trả",
    userOptionLog: "Nhật ký người dùng",
  },
  drawBackLog: {
    amount: "số tiền cược",
    status: "trạng thái",
    accountInfo: "Tài khoản cấp trên",
    userBackName: "thuộc cấp trên",
    proxyGrade: "cấp",
    bonus: "tiền thưởng",
    rebateInfo: "Hoàn trả",
    rebateAmountInfo: "Số tiền hoàn trả",
    rebate: "tỷ lệ hoàn",
    rebateAmount: "số tiền hoàn lại",
    betTime: "thời gian",
    option: "thao tác",
    detail: "chi tiết đơn cược",
    orderId: "số đơn",
    createTime: "thời gian tạo",
    rebateMoney: "tổng tiền hoàn lại"
  },
  amountLog: {
    createTime: "thời gian",
    type: "loại đơn cược",
    amount: "Số tiền giao dịch",
    minAmount: "Số tiền giao dịch tối thiểu",
    maxAmount: "Số tiền giao dịch tối đa",
    amountMsg: "Số tiền giao dịch tối thiểu không được lớn hơn số tiền giao dịch tối đa",
    otherId: "đơn cược liên quan",
    remark: "ghi chú",
    option: "thao tác",
    detail: "Thông tin chi tiết",
    orderDetail: "Chi tiết đơn cược",
    title: "Tiêu đề",
    updateTime: "thời gian thao tác",
    noOrder: "Không tìm thấy mã giao dịch",
    beforeBalance: "Số tiền trước khi",
    afterBalance: "Số tiền sau khi",
    event: "Sự kiện",
    eventId: "Mã sự kiện",
    transferId: "Truyền tải ID",
    transferInfo: "Chi tiết giao dịch",
    remark1: 'Lưu ý: Chỉ lưu giữ hồ sơ chuyển khoản 24 giờ mới nhất',
    remark2: 'Lưu ý: Đăng ký tài khoản dài hơn 3 phút',
    syncTitle: "Đồng bộ biến động số dư",
  },
  bonusSet: {
    name: "trò chơi",
    point: "Hoàn trả",
    status: "Trạng thái hoàn trả hoàn hoa hồng",
    game: "Trò chơi điện tử",
  },
  blacklist: {
    title: "danh sách đen",
    cancel: "Hủy danh sách đen",
    platformCode: "nền tảng bạn thuộc về",
    userId: "tài khoản",
    remark: "ghi chú",
    messageRemark: "Nhập ghi chú",
    messageRemove: "Có loại người dùng đã chọn ra khỏi danh sách đen không"
  },

  userGroup: {
    name: "nhóm người dùng",
    singleMaxRechargeAmount: "Số tiền nạp tối đa cho mỗi lần nạp tiền trực tuyến",
    todayMaxRechargeAmount: "Số tiền nạp tối đa trong ngày",
    singleMaxWithdrawAmount: "Số tiền rút tối đa cho mỗi giao dịch",
    todayMaxWithdrawAmount: "Số tiền rút tối đa trong ngày",
    todayMaxWithdrawCount: "Số lần rút tiền tối đa trong ngày",
    todayMaxNotPayCount: "Số lần chưa thanh toán lớn nhất hôm nay",
    sort: "loại",
    option: "thao tác",
    isDefault: "Mặc định",
    transfer: "gửi",
    transferTo: "gửi đến",
    messageDefault: "đặt làm mặc định?",
    tip1: "Vui lòng nhập 1-15 ký tự",
    tip2: "Vui lòng nhập 1-18 con số",
    tip3: "Vui lòng nhập 1-3 con số",
    tip4: "Nhập số thứ tự",
    setDefault: "Dặt làm mặc định",
  },
  userPortrait: {
    name: "tên",
    link: "ảnh",
    createTime: "thời gian tạo",
    updateUserName: "người thao tác",
    option: "thao tác",
    tip1: "Vui lòng nhập 1-100 ký tự",
    tip2: "Tải hình ảnh lên",
    sort: "loại",
  },
  userLogs: {
    createTime: "thời gian thao tác",
    type: "loại hình",
    platformCode: "nền tảng bạn thuộc về",
    ip: "địa chỉ IP",
    ipAddress: "thông tin IP",
    content: "nội dung thao tác",
    requestUri: "yêu cầu URL",
    params: "dữ liệu mới",
    lastParams: "dữ liệu cũ",
    option: "thao tác",
    info: "xem chi tiết"
  },
  userOnline: {
    account: "Tài khoản cấp trên",
    platformName: "Nền tảng",
    gameName: "trong tro choi",
    loginTime: "lần đăng nhập cuối",
    loginIp: "IP đăng nhập",
    ipAddress: "thông tin IP",
    userDetail: "Chi tiết người dùng",
    offline: "đá ngoại tuyến ",
    proposeRoom: "đá ra khỏi phòng",
    gameCode: "trò chơi",
    messageUserOffline: "OK để khởi động dây chuyền lắp ráp?"
  },
  userForbidden: {
    message1: "确定要取消禁言吗?",
    message2: '请选择要取消禁言的选项',
    message3: '禁言成功',
  }
}
